// material-ui

import transfergoodsicon from '../../../assets/images/TransferGoods.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const TransferGoodsIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={transfergoodsicon} alt="Transfer Goods" width="22"  />
    );
};

export default TransferGoodsIcon;
